import { useRef, useEffect, useState } from 'react';
import { get, set } from 'global/lib/lodash';
import { isEqual } from '../lib/lodash';

export const useIntersect = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    observer.current = new window.IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold,
    });

    const { current: currentObserver } = observer;
    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node, root, rootMargin, threshold]);

  return [setNode, entry];
};

export const useElement = (props) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);

  const track = get(props, 'track', ['offsetTop']);

  useEffect(() => {
    if (node) {
      const interval = setInterval(() => {
        const vals = {};

        track.map(t => {
          set(vals, t, get(node, t));
        })

        if (!isEqual(vals, entry)) {
          updateEntry(vals);
        }
      }, get(props, 'interval', 500));

      return () => {
        clearInterval(interval);
      }
    }
  }, [node, entry]);

  return [setNode, entry];
};
